/* istanbul ignore file */
import { IFormElementBusinessLogic, createFormElement, FormElement } from '@vfde-brix/ws10/form-element';
import { IValidation, InputFieldType } from '@vfde-brix/ws10/validation';
import { HtmlId } from '../enums/elementId';
import { IEventHandler } from '../interface';
import { mountComponent } from '../util/mount';
import { Address } from '@vfde-sails/avc-core';
import { formatAddressText } from '../util/formatter';
import { EMAIL_REGEX } from '../constants';

export const mountFormElement = (wrapperId: HtmlId, handler: IEventHandler, validation?: IValidation[]) => {
    const props: IFormElementBusinessLogic = {
        onInput: handler,
        onChange: handler,
        validation,
    };

    return mountComponent(wrapperId, createFormElement, props);
};

export const updateFormElement = (comp: FormElement | undefined, value: string) => {
    const container = comp?.getContainerElement();
    const input = container?.querySelector('input');

    // Avoid updating value unnecessarily
    if (!input || input.value === value) {
        return;
    }

    // Component update has a bug in writeDom that causes an exception:
    // GET http://eweb8.vfd2-testnet.de/simplicity/icons/.svg net::ERR_ABORTED 404 (Not Found)
    input.value = value;
};

export const updateSelectFormElement = (comp: FormElement | undefined, addresses: Address[]) => {
    if (!comp) {
        return;
    }

    const props = comp.getProperties();

    if ('select' !== props.optInputFieldType || !('items' in props.containerInput)) {
        return;
    }

    props.containerInput.items = addresses.map((address, index) => ({
        stdOptionLabel: formatAddressText(address),
        stdOptionValue: index.toString(),
    }));

    comp.update(props);
};

/**
 * Brix email validation breaks the page with 50 or more characters
 * This is a workaround until that's fixed
 *
 * @param inputFields
 * @returns
 */
export const isEmailValid = (inputFields: InputFieldType[]) => {
    const value = inputFields[0].value.trim();

    // don't do validation if value is undefined, null or ''
    if (!value) {
        return true;
    }

    return value.match(EMAIL_REGEX);
};
